<div class="admin-session-switcher">
  <button class="mobile-options-trigger" type="button" (click)="toggleMobileOptions()" [attr.aria-expanded]="isMobileOptionsOpen" [attr.aria-label]="'adminSessionSwitcher.moreOptions' | translate">
    <span aria-hidden="true">⋮</span>
  </button>

  <div class="switcher-options" [class.open]="isMobileOptionsOpen">
  <!-- Selector de Compañía (solo para admins) -->
  @if (isAdmin && chatbotEnabled) {
    <button class="assistant-button" (click)="goToAssistant()" type="button">
      <span class="assistant-button__peek" aria-hidden="true">
        <span class="assistant-button__peek-bot">🤖</span>
      </span>
      <svg class="assistant-button__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3l1.7 4.6L18.3 9l-4.6 1.7L12 15l-1.7-4.3L6 9l4.3-1.4L12 3z" fill="currentColor" />
        <path class="assistant-button__spark" d="M19 13.5l.9 2.3 2.3.9-2.3.9-.9 2.3-.9-2.3-2.3-.9 2.3-.9.9-2.3z" fill="currentColor" opacity="0.55" />
      </svg>
      <span>{{ 'adminSessionSwitcher.assistantButton' | translate }}</span>
    </button>
  }
  @if (isAdmin && sessions.length > 0) {
    <div class="portal-selector">
      <label style="color: white;">{{ 'adminSessionSwitcher.changeCompany' | translate }}</label>
      <div class="combobox" [class.open]="isSessionDropdownOpen">
        <div class="combobox-input-wrapper" (click)="openSessionDropdown()">
          <input
            type="text"
            class="combobox-input"
            [value]="sessionDisplayValue"
            (input)="onSessionInputChange($event.target['value'])"
            [placeholder]="activeSession ? '' : ('adminSessionSwitcher.searchPlaceholder' | translate)"
            autocomplete="off"
            />
            <span class="combobox-chevron" [class.rotated]="isSessionDropdownOpen">&#x25BE;</span>
          </div>
          @if (isSessionDropdownOpen) {
            <ul class="combobox-dropdown">
              @for (s of filteredSessions; track s) {
                <li
                  class="combobox-option"
                  [class.selected]="s.id.toString() === activePortalId"
                  (click)="selectSession(s)"
                  >
                  {{ s.name }}
                </li>
              }
              @if (filteredSessions.length === 0) {
                <li class="combobox-empty">
                  {{ 'adminSessionSwitcher.noResults' | translate }}
                </li>
              }
            </ul>
          }
        </div>
      </div>
    }

    <!-- Selector de Idioma (visible siempre) -->
    <div class="language-selector">
      <label for="langSelect" style="color: white;">{{ 'adminSessionSwitcher.language' | translate }}</label>
      <select
        id="langSelect"
        [(ngModel)]="currentLang"
        (ngModelChange)="changeLanguage($event)"
        >
        <option value="es">{{ 'adminSessionSwitcher.spanish' | translate }}</option>
        <option value="en">{{ 'adminSessionSwitcher.english' | translate }}</option>
      </select>
    </div>
  </div>
</div>
